<template>
    <box-view class="debt-module" title="Quản lý Công nợ" :showBack="true" @close="$router.push('/admin')">
        <div class="container-fluid py-0 px-0">
            <!-- Tabs Separation -->
            <van-tabs v-model="activeTab" color="#1989fa" sticky>
                <!-- CUSTOMER TAB (RECEIVABLE) -->
                <van-tab title="Khách hàng">
                    <div class="p-3">
                        <div class="row mb-4">
                            <div class="col-12">
                                <div class="summary-card receivable shadow-sm border-0">
                                    <div class="icon-wrapper">
                                        <i class="fas fa-hand-holding-usd"></i>
                                    </div>
                                    <div class="summary-content">
                                        <div class="label">Tổng phải thu</div>
                                        <div class="amount">{{ totalReceivable.toLocaleString() }}₫</div>
                                        <div class="text-muted small mt-1 d-flex justify-content-between">
                                            <span><i class="fas fa-money-bill text-success mr-1"></i> {{ totalReceivableCash.toLocaleString() }}₫</span>
                                            <span><i class="fas fa-university text-primary mr-1"></i> {{ totalReceivableTransfer.toLocaleString() }}₫</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <h6 class="mb-0 text-muted font-weight-bold">DANH SÁCH KHÁCH NỢ</h6>
                            <div class="d-flex align-items-center gap-2">
                                <van-search v-model="searchQuery" placeholder="Tìm ID/Tên/SĐT..." style="padding: 0; background: transparent; width: 140px;" />
                            </div>
                        </div>
                        
                        <!-- Customer Filters -->
                        <div class="row mb-3 align-items-center">
                            <div class="col-8">
                                <div class="d-flex align-items-center">
                                     <div class="custom-control custom-checkbox custom-control-inline mr-3">
                                         <input type="checkbox" class="custom-control-input" id="filterCustomerReceivable" v-model="showCustomerReceivable">
                                         <label class="custom-control-label text-danger font-weight-bold" for="filterCustomerReceivable" style="font-size: 0.85rem">Khách nợ</label>
                                     </div>
                                     <div class="custom-control custom-checkbox custom-control-inline">
                                         <input type="checkbox" class="custom-control-input" id="filterCustomerDeposit" v-model="showCustomerDeposit">
                                         <label class="custom-control-label text-success font-weight-bold" for="filterCustomerDeposit" style="font-size: 0.85rem">Tiền cọc</label>
                                     </div>
                                </div>
                            </div>
                            <div class="col-4">
                                <select v-model="customerSortOrder" class="form-control form-control-sm border-0 bg-light text-muted font-weight-bold" style="font-size: 0.8rem">
                                    <option value="none">Sắp xếp: Mặc định</option>
                                    <option value="desc">Số tiền (Lớn → Bé)</option>
                                    <option value="asc">Số tiền (Bé → Lớn)</option>
                                </select>
                            </div>
                        </div>

                        <div class="row">
                            <div v-for="group in paginatedCustomerGroups" :key="group.key" class="col-12 mb-3">
                                <div class="debt-card card border-0 shadow-sm receivable" @click="viewHistory(group)">
                                    <div class="card-body p-3">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div class="flex-grow-1">
                                                <div class="partner-info mb-1">
                                                    <h6 class="mb-0 font-weight-bold">{{ group.partnerName }}</h6>
                                                </div>
                                                <div class="small text-muted"><i class="fas fa-phone-alt mr-1"></i> {{ group.partnerPhone || '---' }}</div>
                                            </div>
                                            <div class="text-right">
                                                <div class="debt-amount mb-1" :class="group.totalAmount < 0 ? 'text-success' : 'text-danger'">
                                                    {{ group.totalAmount.toLocaleString() }}₫
                                                </div>
                                                <div class="d-inline-flex">
                                                    <button class="btn btn-sm btn-outline-secondary px-2 rounded-pill mr-2" @click.stop="printCurrentDebt(group)" title="In phiếu báo nợ">
                                                        <i class="fas fa-print"></i>
                                                    </button>
                                                    <button v-if="canManageDebt && group.totalAmount < 0" class="btn btn-sm btn-outline-success px-3 rounded-pill" @click.stop="refundDeposit(group)">
                                                        Hoàn cọc
                                                    </button>
                                                    <button v-else-if="canManageDebt" class="btn btn-sm btn-outline-danger px-3 rounded-pill" @click.stop="payment(group)">
                                                        Thanh toán
                                                    </button>
                                                    <div v-else class="text-muted extra-small d-inline-flex align-items-center mb-0 mt-1">{{ group.items.length }} chứng từ</div>
                                                </div>
                                            </div>
                                            <div class="ml-3 text-muted">
                                                <i class="fas fa-chevron-right"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="filteredCustomerGroups.length === 0" class="col-12 text-center py-5 text-muted">
                                <i class="fas fa-user-clock fa-3x mb-3 opacity-25"></i>
                                <p>Không có dữ liệu khách hàng nợ</p>
                            </div>
                        </div>
                        <!-- PAGINATION -->
                        <nav v-if="totalCustomerPages > 1" class="mt-3">
                            <ul class="pagination pagination-sm justify-content-center">
                                <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                    <a class="page-link" href="#" @click.prevent="currentPage--">«</a>
                                </li>
                                <li v-for="page in totalCustomerPages" :key="page" class="page-item" :class="{ active: page === currentPage }">
                                    <a class="page-link" href="#" @click.prevent="currentPage = page">{{ page }}</a>
                                </li>
                                <li class="page-item" :class="{ disabled: currentPage === totalCustomerPages }">
                                    <a class="page-link" href="#" @click.prevent="currentPage++">»</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </van-tab>

                <!-- SUPPLIER TAB (PAYABLE) -->
                <van-tab title="Nhà cung cấp">
                    <div class="p-3">
                        <div class="row mb-4">
                            <div class="col-12">
                                <div class="summary-card payable shadow-sm border-0">
                                    <div class="icon-wrapper">
                                        <i class="fas fa-file-invoice-dollar"></i>
                                    </div>
                                    <div class="summary-content">
                                        <div class="label">Tổng phải trả</div>
                                        <div class="amount">{{ totalPayable.toLocaleString() }}₫</div>
                                        <div class="text-muted small mt-1 d-flex justify-content-between">
                                            <span><i class="fas fa-money-bill text-success mr-1"></i> {{ totalPayableCash.toLocaleString() }}₫</span>
                                            <span><i class="fas fa-university text-primary mr-1"></i> {{ totalPayableTransfer.toLocaleString() }}₫</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <h6 class="mb-0 text-muted font-weight-bold">DANH SÁCH NỢ NCC</h6>
                            <van-search v-model="searchQuery" placeholder="Tìm ID/Tên/SĐT..." style="padding: 0; background: transparent; width: 180px;" />
                        </div>

                        <div class="row">
                            <div v-for="group in paginatedSupplierGroups" :key="group.key" class="col-12 mb-3">
                                <div class="debt-card card border-0 shadow-sm payable" @click="viewHistory(group)">
                                    <div class="card-body p-3">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div class="flex-grow-1">
                                                <div class="partner-info mb-1">
                                                    <h6 class="mb-0 font-weight-bold">{{ group.partnerName }}</h6>
                                                </div>
                                                <div class="small text-muted"><i class="fas fa-phone-alt mr-1"></i> {{ group.partnerPhone || '---' }}</div>
                                            </div>
                                            <div class="text-right">
                                                <div class="debt-amount text-success mb-1">
                                                    {{ group.totalAmount.toLocaleString() }}₫
                                                </div>
                                                <div class="d-inline-flex">
                                                    <button class="btn btn-sm btn-outline-secondary px-2 rounded-pill mr-2" @click.stop="printCurrentDebt(group)" title="In phiếu báo nợ">
                                                        <i class="fas fa-print"></i>
                                                    </button>
                                                    <button v-if="canManageDebt" class="btn btn-sm btn-outline-success px-3 rounded-pill" @click.stop="payment(group)">
                                                        Thanh toán
                                                    </button>
                                                    <div v-else class="text-muted extra-small d-inline-flex align-items-center mb-0 mt-1">{{ group.items.length }} chứng từ</div>
                                                </div>
                                            </div>
                                            <div class="ml-3 text-muted">
                                                <i class="fas fa-chevron-right"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="filteredSupplierGroups.length === 0" class="col-12 text-center py-5 text-muted">
                                <i class="fas fa-truck-loading fa-3x mb-3 opacity-25"></i>
                                <p>Không có dữ liệu nợ nhà cung cấp</p>
                            </div>
                        </div>
                        <!-- PAGINATION -->
                        <nav v-if="totalSupplierPages > 1" class="mt-3">
                            <ul class="pagination pagination-sm justify-content-center">
                                <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                    <a class="page-link" href="#" @click.prevent="currentPage--">«</a>
                                </li>
                                <li v-for="page in totalSupplierPages" :key="page" class="page-item" :class="{ active: page === currentPage }">
                                    <a class="page-link" href="#" @click.prevent="currentPage = page">{{ page }}</a>
                                </li>
                                <li class="page-item" :class="{ disabled: currentPage === totalSupplierPages }">
                                    <a class="page-link" href="#" @click.prevent="currentPage++">»</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </van-tab>

                <!-- HISTORY TAB (ZERO BALANCE) -->
                <van-tab title="Lịch sử">
                    <div class="p-3">
                        <div class="d-flex justify-content-between align-items-center mb-3 mt-2">
                            <h6 class="mb-0 text-muted font-weight-bold">PHIẾU ĐÃ THANH TOÁN XONG</h6>
                            <van-search v-model="searchQuery" placeholder="Tìm ID/Tên/SĐT..." style="padding: 0; background: transparent; width: 180px;" />
                        </div>

                        <div class="row">
                            <div v-for="group in paginatedHistoryGroups" :key="group.key" class="col-12 mb-3">
                                <div class="debt-card card border-0 shadow-sm history-item" @click="viewHistory(group)">
                                    <div class="card-body p-3">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div class="flex-grow-1">
                                                <div class="partner-info d-flex align-items-center mb-1">
                                                    <h6 class="mb-0 font-weight-bold text-muted">{{ group.partnerName }}</h6>
                                                </div>
                                                <div class="small text-muted">
                                                    <span class="badge mr-2" :class="group.partnerType === 'customer' ? 'badge-light' : 'badge-light'">
                                                        {{ group.partnerType === 'customer' ? 'Khách hàng' : 'Nhà cung cấp' }}
                                                    </span>
                                                    {{ group.partnerPhone || '---' }}
                                                </div>
                                            </div>
                                            <div class="text-right">
                                                <div class="debt-amount text-muted mb-0" style="font-size: 0.95rem;">
                                                    Đã trả xong
                                                </div>
                                                <div class="extra-small text-primary">Ngày: {{ formatDateTime(group.items[group.items.length - 1].createdAt) }}</div>
                                            </div>
                                            <div class="ml-3 text-muted">
                                                <i class="fas fa-chevron-right"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="filteredHistoryGroups.length === 0" class="col-12 text-center py-5 text-muted">
                                <i class="fas fa-history fa-3x mb-3 opacity-25"></i>
                                <p>Chưa có lịch sử thanh toán xong</p>
                            </div>
                        </div>
                        <!-- PAGINATION -->
                        <nav v-if="totalHistoryPages > 1" class="mt-3">
                            <ul class="pagination pagination-sm justify-content-center">
                                <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                    <a class="page-link" href="#" @click.prevent="currentPage--">«</a>
                                </li>
                                <li v-for="page in totalHistoryPages" :key="page" class="page-item" :class="{ active: page === currentPage }">
                                    <a class="page-link" href="#" @click.prevent="currentPage = page">{{ page }}</a>
                                </li>
                                <li class="page-item" :class="{ disabled: currentPage === totalHistoryPages }">
                                    <a class="page-link" href="#" @click.prevent="currentPage++">»</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </van-tab>
            </van-tabs>
        </div>

        <div v-if="canManageDebt" class="fab-btn" @click="openModal()">
            <i class="fas fa-plus"></i>
        </div>

        <!-- History & Detail Popup -->
        <van-popup v-model="showHistory" position="bottom" :style="{ height: '90%' }" round closeable>
             <div v-if="selectedGroup" class="d-flex flex-column h-100 p-3">
                  <div class="mb-4">
                       <div class="d-flex align-items-center mb-1">
                            <h5 class="mb-0 font-weight-bold">{{ selectedGroup.partnerName }}</h5>
                       </div>
                       <p class="text-muted small">Chi tiết tất cả chứng từ nợ và thanh toán</p>
                       <div class="d-flex justify-content-between align-items-center bg-light p-3 rounded">
                            <span class="font-weight-bold">DƯ NỢ CUỐI:</span>
                            <span class="h4 mb-0 font-weight-bold" :class="selectedGroup.totalAmount < 0 ? 'text-success' : 'text-danger'">
                                {{ selectedGroup.totalAmount.toLocaleString() }}₫
                            </span>
                       </div>
                  </div>

                  <div class="flex-grow-1 overflow-auto mb-3">
                       <div class="list-group list-group-flush border-top">
                            <div v-for="(item, idx) in selectedGroup.items.slice().reverse()" :key="idx" class="list-group-item px-0 py-3">
                                 <div class="d-flex justify-content-between align-items-start">
                                      <div>
                                           <div class="font-weight-bold mb-1">
                                                <i :class="item.amount < 0 ? 'fas fa-money-bill-wave text-success' : 'fas fa-file-invoice text-primary'" class="mr-2"></i>
                                                {{ item.note || (item.orderId ? 'Đơn hàng #' + item.orderId : 'Ghi nhận nợ') }}
                                           </div>
                                           <div class="small text-muted">
                                               {{ formatDateTime(item.createdAt) }}
                                           </div>
                                      </div>
                                      <div class="text-right">
                                           <div class="font-weight-bold" :class="item.amount < 0 ? 'text-success' : ''">
                                                {{ (item.amount > 0 ? '+' : '') }}{{ item.amount.toLocaleString() }}₫
                                           </div>
                                      </div>
                                 </div>
                            </div>
                       </div>
                  </div>

                  <div v-if="canManageDebt && !selectedGroup.isClosed" class="d-flex gap-2">
                       <button v-if="selectedGroup.totalAmount < 0" class="btn btn-success shadow-sm flex-fill py-3 font-weight-bold" @click="refundDeposit(selectedGroup)">
                            <i class="fas fa-undo mr-2"></i> Hoàn cọc
                       </button>
                       <button v-else class="btn btn-primary shadow-sm flex-fill py-3 font-weight-bold" @click="payment(selectedGroup)">
                            <i class="fas fa-hand-holding-usd mr-2"></i> Thu nợ / Thanh toán
                       </button>
                  </div>
             </div>
        </van-popup>

        <!-- Record Debt Modal -->
        <van-dialog v-model="showModal" :title="editing ? 'Sửa bản ghi' : 'Ghi nhận nợ mới'" show-cancel-button @confirm="save">
            <div class="p-3">
                <div class="form-group">
                    <label class="font-weight-bold"><i class="fas fa-tag mr-1"></i> Loại nợ</label>
                    <select class="form-control" v-model="form.type" @change="form.partnerId = ''; form.partnerName = ''">
                        <option value="receivable">Phải thu (Khách nợ mình)</option>
                        <option value="payable">Phải trả (Mình nợ NCC)</option>
                        <option value="deposit">Tiền cọc (Mình nợ khách)</option>
                    </select>
                </div>
                <div class="form-group">
                    <label class="font-weight-bold"><i class="fas fa-user mr-1"></i> Đối tượng</label>
                    <div class="input-group" @click="showPartnerSelect = true">
                         <input type="text" class="form-control" :value="form.partnerName" placeholder="-- Chọn đối tượng --" readonly style="background: white; cursor: pointer;">
                         <div class="input-group-append">
                             <span class="input-group-text"><i class="fas fa-search"></i></span>
                         </div>
                    </div>
                </div>
                <div class="form-group mb-2">
                    <label class="font-weight-bold"><i class="fas fa-dollar-sign mr-1"></i> Tổng số tiền</label>
                    <div class="form-control text-right bg-light text-danger font-weight-bold" style="font-size: 1.1rem">
                        {{ formAmountTotal.toLocaleString() }}₫
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-6">
                        <div class="d-flex flex-column h-100">
                            <label class="font-weight-bold mb-1 text-nowrap" style="font-size: 0.9rem"><i class="fas fa-money-bill-wave text-success mr-1"></i> Tiền mặt</label>
                            <money-input v-model="form.cash_amount" class="mt-auto" />
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="d-flex flex-column h-100">
                            <label class="font-weight-bold mb-1 text-nowrap" style="font-size: 0.9rem"><i class="fas fa-university text-primary mr-1"></i> Chuyển khoản</label>
                            <money-input v-model="form.transfer_amount" class="mt-auto" />
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="font-weight-bold"><i class="fas fa-sticky-note mr-1"></i> Ghi chú</label>
                    <input type="text" class="form-control" v-model="form.note" placeholder="Nhập lý do nợ...">
                </div>
            </div>
        </van-dialog>

        <!-- Partner Selection Popup -->
        <van-popup v-model="showPartnerSelect" position="bottom" :style="{ height: '70%' }" round>
             <div class="d-flex flex-column h-100">
                  <div class="p-2 border-bottom d-flex align-items-center bg-light">
                      <div class="flex-grow-1 font-weight-bold text-center">Chọn {{ form.type === 'payable' ? 'Nhà cung cấp' : 'Khách hàng' }}</div>
                      <van-icon name="close" class="p-2" @click="showPartnerSelect = false" />
                  </div>
                  <div class="p-2">
                       <van-search v-model="partnerSearchQuery" placeholder="Tìm tên hoặc SĐT..." shape="round" />
                  </div>
                  <div class="flex-grow-1 overflow-auto">
                       <div v-if="filteredPartnerOptions.length === 0" class="text-center text-muted py-4">
                            Không tìm thấy kết quả
                       </div>
                       <div v-else class="list-group list-group-flush">
                            <button v-for="p in filteredPartnerOptions" :key="p.id" class="list-group-item list-group-item-action" @click="selectPartner(p)">
                                 <div class="d-flex justify-content-between align-items-center">
                                      <div>
                                           <div class="font-weight-bold">{{ p.name }}</div>
                                           <div class="small text-muted">{{ p.phone }}</div>
                                      </div>
                                      <i v-if="form.partnerId === p.id" class="van-icon van-icon-success text-success"></i>
                                 </div>
                            </button>
                       </div>
                  </div>
             </div>
        </van-popup>

        <!-- Payment / Refund Dialog -->
        <van-dialog v-model="showPayment" :title="isRefundMode ? 'Hoàn tiền cọc' : 'Thanh toán nợ'" show-cancel-button @confirm="confirmPayment">
            <div class="p-3" v-if="selectedGroup">
                <p>Đối tượng: <strong>{{ selectedGroup.partnerName }}</strong></p>
                <div class="bg-light p-2 mb-3 rounded" v-if="isRefundMode">
                    Tiền cọc hiện tại: <strong class="text-success">{{ Math.abs(selectedGroup.totalAmount).toLocaleString() }}₫</strong>
                </div>
                <div class="bg-light p-2 mb-3 rounded" v-else>
                    Tổng nợ cuối: <strong>{{ selectedGroup.totalAmount.toLocaleString() }}₫</strong>
                </div>
                <div class="form-group mb-2">
                    <label class="font-weight-bold">{{ isRefundMode ? 'Số tiền hoàn cọc' : 'Số tiền thanh toán' }}</label>
                    <div class="form-control text-right bg-light text-danger font-weight-bold" style="font-size: 1.1rem">
                        {{ paymentAmountTotal.toLocaleString() }}₫
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-6">
                        <div class="d-flex flex-column h-100">
                            <label class="font-weight-bold mb-1 text-nowrap" style="font-size: 0.9rem"><i class="fas fa-money-bill-wave text-success mr-1"></i> Tiền mặt</label>
                            <money-input v-model="paymentCashAmount" class="mt-auto" />
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="d-flex flex-column h-100">
                            <label class="font-weight-bold mb-1 text-nowrap" style="font-size: 0.9rem"><i class="fas fa-university text-primary mr-1"></i> Chuyển khoản</label>
                            <money-input v-model="paymentTransferAmount" class="mt-auto" />
                        </div>
                    </div>
                </div>
                
                <!-- Hiển thị Tiền thừa và Checkbox cọc nếu dư nợ (Chỉ khi thanh toán thu nợ, không dùng cho Hoàn Cọc) -->
                <div v-if="!isRefundMode && excessAmount > 0" class="mt-3 p-2 border rounded" style="background-color: #f8f9fa;">
                    <div class="d-flex align-items-center text-success mb-2">
                         <i class="fas fa-hand-holding-usd mr-2" style="font-size: 1.2rem;"></i>
                         <span class="font-weight-bold" style="font-size: 1.1rem;">👉 Tiền thừa: {{ excessAmount.toLocaleString() }}₫</span>
                    </div>
                    <div class="custom-control custom-checkbox ml-1">
                         <input type="checkbox" class="custom-control-input" id="debtDepositCb" v-model="convertToDeposit">
                         <label class="custom-control-label text-muted small font-weight-bold" for="debtDepositCb" style="cursor: pointer; line-height: 1.5;">
                              Chuyển tiền thừa thành Tiền cọc (trừ vào công nợ)
                         </label>
                    </div>
                </div>
                <div class="form-group mt-3">
                    <label class="font-weight-bold">Ghi chú (Tùy chọn)</label>
                    <input type="text" class="form-control form-control-sm" v-model="paymentNote" placeholder="Ghi chú thêm...">
                </div>
            </div>
        </van-dialog>
    </box-view>
</template>

<script>
export default {
    name: 'Debt',
    props: {
        debts: {
            type: Array,
            default: () => []
        },
        customers: {
            type: Array,
            default: () => []
        },
        suppliers: {
            type: Array,
            default: () => []
        },
        user: {
            type: Object,
            default: () => ({})
        },
        settings: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            activeTab: 0,
            searchQuery: '',
            partnerSearchQuery: '',
            showModal: false,
            showPayment: false,
            showHistory: false,
            showPartnerSelect: false,
            editing: false,
            form: {
                id: null,
                partnerId: '',
                partnerName: '',
                partnerType: 'customer',
                type: 'receivable',
                amount: 0,
                cash_amount: 0,
                transfer_amount: 0,
                note: ''
            },
            selectedGroup: null,
            paymentAmount: 0,
            paymentCashAmount: 0,
            paymentTransferAmount: 0,
            maxPaymentAmount: 0,
            isAdjustingPayment: false,
            paymentNote: '',
            isRefundMode: false,
            currentPage: 1,
            pageSize: 30,
            
            // Filters
            showCustomerReceivable: true,
            showCustomerDeposit: true,
            customerSortOrder: 'none',
            convertToDeposit: true
        };
    },
    computed: {
        excessAmount() {
            if (!this.showPayment) return 0;
            const diff = this.paymentAmountTotal - this.maxPaymentAmount;
            return diff > 0 ? diff : 0;
        },
        canManageDebt() {
            const role = this.user.role || 'admin';
            if(role === 'admin') return true;
            const roleConfig = this.settings.user?.roles?.[role];
            return roleConfig?.permissions?.includes('manageDebt');
        },
        formAmountTotal() {
            return Number(this.form.cash_amount || 0) + Number(this.form.transfer_amount || 0);
        },
        paymentAmountTotal() {
            return Number(this.paymentCashAmount || 0) + Number(this.paymentTransferAmount || 0);
        },
        totalReceivable() {
            return this.debts.filter(d => d.type === 'receivable').reduce((acc, d) => acc + parseFloat(d.amount), 0);
        },
        totalReceivableCash() {
            return this.debts.filter(d => d.type === 'receivable').reduce((acc, d) => acc + parseFloat(d.cash_amount || d.amount || 0), 0); // For compatibility with old data
        },
        totalReceivableTransfer() {
            return this.debts.filter(d => d.type === 'receivable').reduce((acc, d) => acc + parseFloat(d.transfer_amount || 0), 0);
        },
        totalPayable() {
            return this.debts.filter(d => d.type === 'payable').reduce((acc, d) => acc + parseFloat(d.amount), 0);
        },
        totalPayableCash() {
            return this.debts.filter(d => d.type === 'payable').reduce((acc, d) => acc + parseFloat(d.cash_amount || d.amount || 0), 0);
        },
        totalPayableTransfer() {
            return this.debts.filter(d => d.type === 'payable').reduce((acc, d) => acc + parseFloat(d.transfer_amount || 0), 0);
        },
        allGroupedDebts() {
            if (!Array.isArray(this.debts)) return [];
            
            // 1. Group by partner first
            const partnerGroups = {};
            // Robust Sort: Prioritize Numeric ID over Date to handle client/server clock desync
            const sortedDebts = [...this.debts].sort((a, b) => {
                const getNumericId = (id) => {
                    if (!id) return 0;
                    if (typeof id === 'number') return id;
                    const match = String(id).match(/\d+/);
                    return match ? parseInt(match[0]) : 0;
                };

                const idA = getNumericId(a.id);
                const idB = getNumericId(b.id);
                
                // If IDs are different and numeric, rely on them for sequence
                if (idA !== idB && idA > 0 && idB > 0) return idA - idB;

                // Fallback to Date if IDs are same or not parseable
                const dateA = new Date(a.createdAt).getTime() || 0;
                const dateB = new Date(b.createdAt).getTime() || 0;
                return dateA - dateB;
            });

            sortedDebts.forEach(d => {
                const key = `${d.partnerType}-${d.partnerId}`;
                if (!partnerGroups[key]) partnerGroups[key] = [];
                partnerGroups[key].push(d);
            });

            const allSessions = [];

            // 2. Process each partner's transactions into sessions (Toa)
            Object.values(partnerGroups).forEach(transactions => {
                let currentSession = null;
                let runningBalance = 0;
                let sessionCounter = 0;

                const startNewSession = (firstItem) => ({
                    key: `${firstItem.partnerType}-${firstItem.partnerId}-toa-${++sessionCounter}-${Date.now()}-${Math.floor(Math.random() * 1000)}`,
                    partnerId: firstItem.partnerId,
                    partnerName: firstItem.partnerName || this.getPartnerNameFromProp(firstItem.partnerId, firstItem.partnerType),
                    partnerPhone: firstItem.partnerPhone || '',
                    partnerType: firstItem.partnerType,
                    type: firstItem.type,
                    totalAmount: 0,
                    items: [],
                    isClosed: false
                });

                transactions.forEach(d => {
                    let amountToProcess = parseFloat(d.amount) || 0;

                    // Support splitting a single transaction across multiple sessions if it crosses 0
                    while (Math.abs(amountToProcess) > 0.01) {
                        if (!currentSession) {
                            currentSession = startNewSession(d);
                            runningBalance = 0;
                        }

                        let amountUsed = amountToProcess;
                        let sessionEnds = false;

                        // Identify hit-zero or cross-zero points
                        if (runningBalance > 0 && amountToProcess < 0) {
                            // Debt exists -> paying off
                            if (runningBalance + amountToProcess <= 0.1) {
                                amountUsed = -runningBalance; // Use only enough to reach 0
                                sessionEnds = true;
                            }
                        } else if (runningBalance < 0 && amountToProcess > 0) {
                            // Credit exists -> using up credit
                            if (runningBalance + amountToProcess >= -0.1) {
                                amountUsed = -runningBalance; // Use only enough to reach 0
                                sessionEnds = true;
                            }
                        } else if (Math.abs(runningBalance + amountToProcess) < 0.1) {
                            // Exact hit
                            sessionEnds = true;
                        }

                        currentSession.items.push({
                            ...d,
                            amount: amountUsed,
                            originalAmount: amountUsed,
                            _sessionIndex: sessionCounter
                        });

                        runningBalance += amountUsed;
                        amountToProcess -= amountUsed;

                        if (sessionEnds) {
                            currentSession.totalAmount = 0;
                            currentSession.isClosed = true;
                            allSessions.push(currentSession);
                            currentSession = null;
                            runningBalance = 0;
                        } else {
                            // Amount used but session remains open, no more splitting needed for THIS transaction
                            break; 
                        }
                    }
                });

                if (currentSession && currentSession.items.length > 0) {
                    currentSession.totalAmount = runningBalance;
                    allSessions.push(currentSession);
                }
            });

            // Clean up session items and status
            allSessions.forEach(s => {
                s.totalAmount = s.items.reduce((sum, i) => sum + i.amount, 0);
                s.unpaidItems = s.isClosed ? [] : s.items; 
                s.paidItems = s.isClosed ? s.items : [];
            });

            // Debug Logging: Helpful to see why items might be jumping
            console.log('Processed Debt Sessions:', allSessions.map(s => ({
                partner: s.partnerName,
                count: s.items.length,
                balance: s.totalAmount,
                closed: s.isClosed,
                items: s.items.map(i => `${i.id}: ${i.amount}`)
            })));

            return allSessions;
        },
        filteredCustomerGroups() {
            // Only show active (unpaid/credit) sessions for customers
            let list = this.allGroupedDebts.filter(g => g.partnerType === 'customer' && !g.isClosed);
            
            // Filter by type (Receivable vs Deposit)
            if (!this.showCustomerReceivable && !this.showCustomerDeposit) {
                list = [];
            } else if (this.showCustomerReceivable && !this.showCustomerDeposit) {
                // Receivable means customer owes us, so balance > 0
                list = list.filter(g => g.totalAmount > 0);
            } else if (!this.showCustomerReceivable && this.showCustomerDeposit) {
                // Deposit means we owe customer, so balance < 0
                list = list.filter(g => g.totalAmount < 0);
            }
            
            list = this.applySearchFilter(list);
            
            // Sorting
            if (this.customerSortOrder === 'desc') {
                list.sort((a, b) => Math.abs(b.totalAmount) - Math.abs(a.totalAmount));
            } else if (this.customerSortOrder === 'asc') {
                list.sort((a, b) => Math.abs(a.totalAmount) - Math.abs(b.totalAmount));
            }
            
            return list;
        },
        filteredSupplierGroups() {
            // Only show active (unpaid/credit) sessions for suppliers
            const list = this.allGroupedDebts.filter(g => g.partnerType === 'supplier' && !g.isClosed);
            return this.applySearchFilter(list);
        },
        filteredHistoryGroups() {
            // ONLY show closed sessions
            const list = this.allGroupedDebts.filter(g => g.isClosed);

            // Sort by latest transaction date in each session (descending)
            list.sort((a, b) => {
                 const lastA = a.items[a.items.length - 1]?.createdAt || 0;
                 const lastB = b.items[b.items.length - 1]?.createdAt || 0;
                 return new Date(lastB) - new Date(lastA);
            });
            
            return this.applySearchFilter(list);
        },
        partnerOptions() {
            if (this.form.type === 'receivable' || this.form.type === 'deposit') {
                 return this.customers.map(c => ({ id: c.id, name: c.name, phone: c.phone }));
            } else {
                 return this.suppliers.map(s => ({ id: s.id, name: s.name, phone: s.phone }));
            }
        },
        filteredPartnerOptions() {
            if (!this.partnerSearchQuery) return this.partnerOptions;
            const q = this.partnerSearchQuery.toLowerCase();
            return this.partnerOptions.filter(p => 
                (p.name && p.name.toLowerCase().includes(q)) || 
                (p.phone && p.phone.includes(q))
            );
        },
        totalCustomerPages() {
            return Math.ceil(this.filteredCustomerGroups.length / this.pageSize);
        },
        paginatedCustomerGroups() {
            const start = (this.currentPage - 1) * this.pageSize;
            return this.filteredCustomerGroups.slice(start, start + this.pageSize);
        },
        totalSupplierPages() {
            return Math.ceil(this.filteredSupplierGroups.length / this.pageSize);
        },
        paginatedSupplierGroups() {
            const start = (this.currentPage - 1) * this.pageSize;
            return this.filteredSupplierGroups.slice(start, start + this.pageSize);
        },
        totalHistoryPages() {
            return Math.ceil(this.filteredHistoryGroups.length / this.pageSize);
        },
        paginatedHistoryGroups() {
            const start = (this.currentPage - 1) * this.pageSize;
            return this.filteredHistoryGroups.slice(start, start + this.pageSize);
        }
    },
    watch: {
        activeTab() {
            this.currentPage = 1;
        },
        paymentCashAmount() {
            // Disabled auto-adjustment to allow overpayments
        },
        paymentTransferAmount() {
            // Disabled auto-adjustment to allow overpayments
        }
    },
    methods: {
        applySearchFilter(groups) {
            if (!this.searchQuery) return groups;
            const q = this.searchQuery.toLowerCase();
            return groups.filter(g => 
                (g.partnerName && g.partnerName.toLowerCase().includes(q)) || 
                (g.partnerPhone && g.partnerPhone.includes(q)) ||
                (g.partnerId && String(g.partnerId).includes(q))
            );
        },
        getPartnerNameFromProp(id, type) {
            if (type === 'customer') {
                const c = this.customers.find(x => x.id === id);
                return c ? c.name : 'Khách lẻ (#' + id + ')';
            } else {
                const s = this.suppliers.find(x => x.id === id);
                return s ? s.name : 'Nhà cung cấp (#' + id + ')';
            }
        },
        formatDateTime(iso) {
            if (!iso) return '---';
            return new Date(iso).toLocaleString('vi-VN');
        },
        viewHistory(group) {
            this.selectedGroup = group;
            this.showHistory = true;
        },
        openModal() {
            this.editing = false;
            // Default type based on active tab
            const type = this.activeTab === 0 ? 'receivable' : (this.activeTab === 1 ? 'payable' : 'receivable');
            this.form = {
                partnerId: '',
                partnerName: '',
                partnerType: type === 'payable' ? 'supplier' : 'customer',
                type: type,
                amount: 0,
                cash_amount: 0,
                transfer_amount: 0,
                note: ''
            };
            this.showModal = true;
            this.partnerSearchQuery = ''; 
        },
        selectPartner(partner) {
            this.form.partnerId = partner.id;
            this.form.partnerName = partner.name;
            this.form.partnerType = this.form.type === 'payable' ? 'supplier' : 'customer';
            this.showPartnerSelect = false;
        },
        save() {
            if (!this.form.partnerName || this.formAmountTotal <= 0) {
                this.$toast?.fail('Vui lòng kiểm tra lại thông tin');
                return;
            }
            this.form.amount = this.formAmountTotal;
            this.$emit('add-debt', this.form);
            this.showModal = false;
        },
        payment(group) {
            this.selectedGroup = group;
            this.isRefundMode = false;
            const total = group.totalAmount > 0 ? group.totalAmount : 0;
            this.maxPaymentAmount = total;
            this.isAdjustingPayment = true;
            this.paymentCashAmount = total;
            this.paymentTransferAmount = 0;
            this.convertToDeposit = true; // Reset checkbox state when modal opens
            this.$nextTick(() => { this.isAdjustingPayment = false; });
            this.paymentNote = '';
            this.showPayment = true;
        },
        refundDeposit(group) {
            this.selectedGroup = group;
            this.isRefundMode = true;
            const total = Math.abs(group.totalAmount);
            this.maxPaymentAmount = total;
            this.isAdjustingPayment = true;
            this.paymentCashAmount = total;
            this.paymentTransferAmount = 0;
            this.$nextTick(() => { this.isAdjustingPayment = false; });
            this.paymentNote = '';
            this.showPayment = true;
        },
        confirmPayment() {
            if (this.paymentAmountTotal <= 0) {
                this.$toast?.fail('Số tiền không hợp lệ');
                return;
            }

            let finalNote = '';
            const creatorName = this.user?.first_name || this.user?.name || 'Admin';

            if (this.isRefundMode) {
                finalNote = `[Hoàn cọc] Hoàn tiền cọc cho ${this.selectedGroup.partnerName} | Người thực hiện: ${creatorName}`;
                if (this.paymentNote) finalNote += ` - ${this.paymentNote}`;
                
                // Refund deposit: create a positive debt to offset the negative deposit
                this.$emit('add-debt', {
                    partnerId: this.selectedGroup.partnerId,
                    partnerName: this.selectedGroup.partnerName,
                    partnerType: 'customer',
                    type: 'receivable',
                    amount: this.paymentAmountTotal,
                    cash_amount: this.paymentCashAmount,
                    transfer_amount: this.paymentTransferAmount,
                    note: finalNote,
                    prePaymentDebt: this.selectedGroup.totalAmount
                });
            } else {
                // Handle overpayment logically
                let actualPaymentAmount = this.paymentAmountTotal;
                let actualCash = this.paymentCashAmount;
                let actualTransfer = this.paymentTransferAmount;

                if (this.excessAmount > 0 && !this.convertToDeposit) {
                    // Overpaid but did not convert to deposit -> Cap payment at maximum debt (rest is change)
                    actualPaymentAmount = this.maxPaymentAmount;
                    
                    // Propotionally adjust cash and transfer downwards if we need to cap
                    if (actualCash >= actualPaymentAmount) {
                        actualCash = actualPaymentAmount;
                        actualTransfer = 0;
                    } else {
                        // All cash is kept, transfer handles the rest up to max limit
                        actualTransfer = actualPaymentAmount - actualCash;
                    }
                }

                if (this.excessAmount > 0 && this.convertToDeposit) {
                     finalNote = `Thu nợ & Cọc: ${this.selectedGroup.partnerName} | Người thực hiện: ${creatorName}`;
                     if (this.paymentNote) finalNote += ` - ${this.paymentNote}`;
                } else {
                     finalNote = `Thanh toán nợ: ${this.selectedGroup.partnerName} | Người thực hiện: ${creatorName}`;
                     if (this.paymentNote) finalNote += ` - ${this.paymentNote}`;
                }

                this.$emit('pay-debt', {
                    partnerId: this.selectedGroup.partnerId,
                    partnerType: this.selectedGroup.partnerType,
                    partnerName: this.selectedGroup.partnerName,
                    type: this.selectedGroup.type,
                    amount: actualPaymentAmount,
                    cash_amount: actualCash,
                    transfer_amount: actualTransfer,
                    note: finalNote,
                    prePaymentDebt: this.selectedGroup.totalAmount,
                    convertToDeposit: this.convertToDeposit // Passed for downstream use if necessary
                });
            }

            this.showPayment = false;
            this.showHistory = false;
        },
        printCurrentDebt(group) {
            const creatorName = this.user?.first_name || this.user?.name || 'Admin';
            let partnerPhone = group.partnerPhone;
            
            // Try fetch phone if missing
            if (!partnerPhone) {
                if (group.partnerType === 'supplier') {
                    const s = this.suppliers.find(x => x.id === group.partnerId);
                    if (s) partnerPhone = s.phone;
                } else {
                    const c = this.customers.find(x => x.id === group.partnerId);
                    if (c) partnerPhone = c.phone;
                }
            }

            const receiptData = {
                isCurrentDebt: true,
                partnerType: group.partnerType,
                partnerName: group.partnerName || group.partnerId,
                partnerPhone: partnerPhone || '',
                createdAt: new Date().toISOString(),
                createdBy: creatorName,
                currentDebt: group.totalAmount
            };
            
            this.$emit('print-current-debt', receiptData);
        }
    }
};
</script>

<style scoped>
.summary-card {
    display: flex;
    align-items: center;
    background: white;
    padding: 1.25rem;
    border-radius: 12px;
}
.icon-wrapper {
    width: 44px;
    height: 44px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.4rem;
    margin-right: 1rem;
}
.receivable .icon-wrapper { background: #fee2e2; color: #ef4444; }
.payable .icon-wrapper { background: #dcfce7; color: #22c55e; }
.label { font-size: 0.8rem; color: #6b7280; font-weight: 500; text-transform: uppercase; letter-spacing: 0.5px; }
.amount { font-size: 1.5rem; font-weight: 800; color: #111827; }

.debt-card {
    cursor: pointer;
    transition: transform 0.15s;
    border-left: 5px solid transparent !important;
}
.debt-card:active {
    transform: scale(0.98);
}
.receivable.debt-card { border-left-color: #ef4444 !important; }
.payable.debt-card { border-left-color: #22c55e !important; }
.history-item.debt-card { border-left-color: #9ca3af !important; opacity: 0.9; }

.debt-amount {
    font-size: 1.2rem;
    font-weight: 800;
}
.extra-small {
    font-size: 0.7rem;
}
.fab-btn {
    position: fixed;
    right: 20px;
    bottom: 30px;
    width: 56px;
    height: 56px;
    background: #1989fa;
    color: white;
    border-radius: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
    box-shadow: 0 4px 12px rgba(25, 137, 250, 0.4);
    z-index: 100;
}
</style>
